import styled from 'styled-components';

/* ===== Identidade visual (alinhada ao login / Header) =====
   --primary: #ff6d3c   --muted: #79869e
   --border:  rgba(216, 224, 235, 0.9)
   --header-bg: #f1f5f9
=========================================================== */

export const Table = styled.table`
  border-spacing: 0;
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 12px;
  overflow: hidden;

  thead {
    position: sticky;
    top: 0;
    z-index: 2;
  }

  tr {
    input {
      background: transparent;
    }

    &:nth-child(even) {
      background: #fafbfd;
    }

    &:hover {
      background: rgba(255, 109, 60, 0.05);
    }

    :last-child {
      td {
        border-bottom: 0;
      }
    }
  }

  th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #f1f5f9;
    color: #334155;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    text-align: left;
  }

  th,
  td {
    margin: 0;
    border-bottom: 1px solid rgba(216, 224, 235, 0.9);
    border-right: 1px solid rgba(216, 224, 235, 0.9);

    :last-child {
      border-right: 0;
    }

    input {
      width: 100%;
      padding: 5px 8px;
      border: 1px solid transparent;
      border-radius: 8px;
      font-size: inherit;
      transition: border-color 0.2s ease, background 0.2s ease,
        box-shadow 0.2s ease;

      &:focus {
        outline: none;
        border-color: #ff6d3c;
        background: rgba(255, 109, 60, 0.08);
        box-shadow: 0 0 0 3px rgba(255, 109, 60, 0.12);
      }
    }

    button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
      border: none;
      border-radius: 8px;
      background: transparent;
      color: #f87171;
      font-size: 16px;
      cursor: pointer;
      transition: color 0.2s ease, background 0.2s ease;

      &:disabled {
        color: #ccc;
        cursor: not-allowed;
      }

      &:hover:not(:disabled) {
        color: #dc2626;
        background: rgba(220, 38, 38, 0.1);
      }
    }

    .resizer {
      position: absolute;
      right: 0;
      top: 0;
      width: 8px;
      height: 100%;
      cursor: col-resize;
      background: transparent;
      transition: background 0.2s ease;

      &.isResizing {
        background: #ff6d3c;
      }

      &:hover {
        background: rgba(255, 109, 60, 0.5);
      }
    }
  }
`;

export const Pagination = styled.nav`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px 0;
  font-size: 14px;

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    margin: 0 4px;
    border: 1px solid rgba(216, 224, 235, 0.9);
    border-radius: 10px;
    background: #fff;
    color: #2c405a;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease,
      box-shadow 0.2s ease, transform 0.2s ease;

    &:disabled {
      color: #cbd0d8;
      border-color: rgba(216, 224, 235, 0.6);
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      color: #fff;
      background: linear-gradient(
        135deg,
        #ff6d3c 0%,
        #ff875f 52%,
        #ff9b78 100%
      );
      border-color: transparent;
      box-shadow: 0 8px 18px rgba(255, 109, 60, 0.3);
      transform: translateY(-1px);
    }
  }

  span {
    display: flex;
    align-items: center;
    margin: 0 6px;
    color: #4a5b72;

    input {
      width: 64px;
      margin: 0 5px;
      padding: 6px;
      border: 1px solid rgba(216, 224, 235, 0.9);
      border-radius: 10px;
      background-color: #f8fafc;
      text-align: center;
      font-size: inherit;
      outline: none;
      transition: border-color 0.2s ease, box-shadow 0.2s ease,
        background 0.2s ease;

      &:focus {
        border-color: #ff6d3c;
        background: #fff;
        box-shadow: 0 0 0 3px rgba(255, 109, 60, 0.12);
      }
    }
  }
`;

export const OperationsContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 7px 12px;
    border: 1px solid rgba(216, 224, 235, 0.9);
    border-radius: 10px;
    background: #fff;
    color: #2c405a;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease,
      box-shadow 0.2s ease, transform 0.2s ease;

    &:hover {
      color: #ef4444;
      background: rgba(239, 68, 68, 0.08);
      border-color: rgba(239, 68, 68, 0.4);
      transform: translateY(-1px);
    }

    &:disabled {
      color: #cbd0d8;
      border-color: rgba(216, 224, 235, 0.6);
      cursor: not-allowed;
      transform: none;
    }

    svg {
      margin-right: 5px;
    }
  }
`;
